const initial = (str: string) => str.charAt(0);

export const initials = (name: string) => {
	return name.trim().split(' ').slice(0, 3).map(initial).join('').toUpperCase();
};
